/*
 * Pagination dashes for the mobile comparison cards.
 *
 * The swipe itself is CSS (`overflow-x` + `scroll-snap`), so this only mirrors the scroll
 * position onto the dashes and lets a dash scroll to its card. With the script blocked the
 * cards still swipe; only the indicator stops moving.
 */

class VpCompareTable extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ct-track]');
    this.dots = [...this.querySelectorAll('[data-ct-dot]')];
    if (!this.track || !this.dots.length) return;

    this.cards = [...this.track.querySelectorAll('[data-ct-card]')];

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => {
      const card = this.cards[i];
      if (!card) return;
      // scrollIntoView would also scroll the page vertically; move the track itself.
      this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }));

    this.track.addEventListener('scroll', () => this.#schedule(), { passive: true });
    this.observer = new ResizeObserver(() => this.#schedule());
    this.observer.observe(this.track);
    this.#schedule();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  #schedule() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.#update());
  }

  #update() {
    // Nearest card to the track's leading edge, rather than a rounded division: the cards are
    // a viewport-relative width and the last one cannot always reach the start.
    const origin = this.track.scrollLeft + this.track.offsetLeft;
    let best = 0;
    let bestGap = Infinity;
    this.cards.forEach((card, i) => {
      const gap = Math.abs(card.offsetLeft - origin);
      if (gap < bestGap) { bestGap = gap; best = i; }
    });
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === best ? 'true' : 'false'));
  }
}

if (!customElements.get('vp-compare-table')) {
  customElements.define('vp-compare-table', VpCompareTable);
}
